import React from "react";

const ImageComingSoon = ({ className = "", style = {} }) => {
  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center ${className}`}
      style={{
        backgroundColor: "#e9ecef",
        color: "#6c757d",
        width: "100%",
        height: "100%",
        minHeight: "150px",
        ...style,
      }}
    >
      <i className="bi bi-image" style={{ fontSize: "2.5rem", opacity: 0.5 }}></i>
      <span className="mt-2 small fw-medium">Image Coming Soon</span>
    </div>
  );
};

export default ImageComingSoon;